export const WIDGET_GET_HUBS_WITHOUT_READINGS_COUNT = 'widget-get-hubs-without-readings-count';
export const WIDGET_GET_HUBS_WITHOUT_READINGS_COUNT_RESULT = `${WIDGET_GET_HUBS_WITHOUT_READINGS_COUNT}/result`;
export const WIDGET_GET_HUBS_WITHOUT_READINGS_COUNT_ERROR = `${WIDGET_GET_HUBS_WITHOUT_READINGS_COUNT}/error`;
